import { API } from "@/lib/api";

function landingReferrer() {
  try {
    let ref = sessionStorage.getItem("hh_ref");
    if (!ref) {
      const host = document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, "") : "";
      ref = host && host !== window.location.hostname.replace(/^www\./, "") ? host : "direct";
      sessionStorage.setItem("hh_ref", ref);
    }
    return ref;
  } catch (e) {
    return "direct";
  }
}

landingReferrer();

export function trackBuyClick(productId, page = window.location.pathname) {
  const body = JSON.stringify({ product_id: productId, page, referrer: landingReferrer() });
  const url = `${API}/clicks`;
  if (navigator.sendBeacon) {
    navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
  } else {
    fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
  }
}
